import { Box, Button, Flex, Text } from '@chakra-ui/react';
import { Bell } from 'lucide-react';
import { Capacitor } from '@capacitor/core';

interface NotificationsEmptyStateProps {
  isOrgAccount: boolean;
  onRefresh: () => void;
}

export function NotificationsEmptyState({ isOrgAccount, onRefresh }: NotificationsEmptyStateProps) {
  // PullToRefresh only runs on native, so the web needs an explicit button.
  const canPullToRefresh = Capacitor.isNativePlatform();

  return (
    <Flex direction="column" align="center" textAlign="center" gap="2" px="6" pt={{ base: 16, lg: 24 }}>
      <Flex
        w="112px"
        h="112px"
        mb="4"
        borderRadius="full"
        bg="rgba(0, 122, 255, 0.08)"
        align="center"
        justify="center"
      >
        <Flex
          w="76px"
          h="76px"
          borderRadius="full"
          bg="white"
          boxShadow="0 4px 12px rgba(31, 41, 50, 0.1)"
          align="center"
          justify="center"
        >
          <Bell size={32} color="#007AFF" aria-hidden />
        </Flex>
      </Flex>
      <Text as="h2" m="0" fontSize="22px" lineHeight="28px" fontWeight="bold" color="volyx.text">
        No notifications yet
      </Text>
      <Text m="0" maxW="300px" fontSize="14px" lineHeight="20px" color="volyx.textMuted">
        {isOrgAccount
          ? 'When volunteers apply to events, request membership, submit tasks, or ask for hours, you’ll see it here.'
          : 'When organizers update your membership, events, or tasks, you’ll see it here.'}
      </Text>
      <Box pt="3">
        {canPullToRefresh ? (
          <Text m="0" fontSize="13px" color="volyx.textSecondary">
            Pull down to refresh
          </Text>
        ) : (
          <Button variant="outline" size="sm" bg="white" borderColor="volyx.borderLight" onClick={onRefresh}>
            Refresh
          </Button>
        )}
      </Box>
    </Flex>
  );
}
